<template>
  <van-overlay class-name="overlay" :show="showAlert" @click="showAlert = false">
    <div @click.stop="" class="new-word-container"
         :style="isArrowUp ? {position: 'absolute', top: alertY + 'px'} : {position: 'absolute', bottom: alertY + 'px'}">
      <div v-if="isArrowUp" class="word-arrow" :style="{position: 'relative', left: x + 'px'}">
        <span class="icon iconfont arrow">&#xe606;</span>
      </div>
      <div class="word-container">
        <div class="word-and-btn">
          <span class="word">{{word && word.wordName}}</span>
          <van-button v-if="showShengci && word.wordId" class="new-word-btn" :class="{'sel-new-word-btn': isAddToNewWord}" plain round type="info"
                      @click="action_newword()">{{btnword}}
          </van-button>
        </div>
        <div v-if="word && !word.wordId" class="no-word-desc">不好意,该单词未收录~</div>
        <div class="pronounce-wrapper">
          <div v-if="word.ukSpeech" class="pronounce-btn" :class="{'pronounce-btn-sel': word.ukSpeech && word.ukSpeech == curAudioUrl}"
               @click="action_pronounce(word.ukSpeech)">
            英: {{word.ukPhonetic}}
            <van-icon class="icon" name="volume-o"/>
          </div>
          <div v-if="word.usSpeech" class="pronounce-btn" :class="{'pronounce-btn-sel': word.usSpeech && word.usSpeech == curAudioUrl}"
               @click="action_pronounce(word.usSpeech)">
            美: {{word.usPhonetic}}
            <van-icon class="icon" name="volume-o"/>
          </div>
          <audio
            ref="audioPlayer"
            :src="curAudioUrl"
            @ended="audioEnd"
          ></audio>
        </div>
        <div class="word-explain">{{explainWord}}</div>
      </div>
      <div v-if="!isArrowUp" class="word-arrow" :style="{position: 'relative', left: x + 'px'}">
        <span class="icon iconfont arrow">&#xe600;</span>
      </div>
    </div>
  </van-overlay>
</template>

<script>
  import {postAddWord} from "@/api/vocab";
  import * as ActionTypes from "@/store/action-types";

  export default {
    name: "ShengciAlert",
    props: {
      showShengci:{
        type: Boolean,
        default: true
      },
      showNewWord: {
        type: Boolean
      },
      x: {
        type: Number,
        default: 10,
      },
      y: {
        type: Number,
        default: 10,
      },
      wordInfo: {
        type: Object,
        default: {},
      },
      contentId: {
        type: String | Number,
        default: '',
      },
    },
    data() {
      return {
        isAddToNewWord: this.wordInfo.hasAdd,//是否添加到生词本,
        isArrowUp: true, //true向上  false向下
        alertY: 0, //计算后使用的纵坐标
        curAudioUrl: '',
      }
    },

    computed: {
      showAlert: {
        get() {
          return this.showNewWord
        },
        set(val) {
          this.$emit('changelBlock', val)
        }
      },
      btnword() {
        return this.isAddToNewWord ? '查看生词本' : '+ 生词本'
      },
      word(){
        return this.wordInfo.word || {}
      },
      explainWord() {
        let wordExplain = ''
        this.word.explains && this.word.explains.forEach(item => {
          wordExplain = `${wordExplain}${item}\n`
        })
        return wordExplain;
      },

    },

    watch: {
      showAlert(val) {
        if (!val) {
          return
        }
        //视口的高度
        let clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

        if (this.y >= clientHeight * 0.5) {
          this.isArrowUp = false
          this.alertY = clientHeight - (this.y - 22 * 0.6);
        } else {
          this.isArrowUp = true
          this.alertY = this.y + 22 * 0.6;
        }
      },

      'wordInfo': {
        handler(val, oval){
          this.isAddToNewWord = val && val.hasAdd;
        },
        deep: true
      },
    },

    methods: {
      //点击+ 生词本/查看生词本
      action_newword() {
        // console.log(this.wordInfo)
        if (this.isAddToNewWord) {
          this.showAlert = false;
          setTimeout(() => {
            this.$router.push({
              path: '/newwordbook'
            })
          }, 200)
        } else {
          this.request_postAddWord()
          this.isAddToNewWord = true;
        }
      },
      //点击发音
      action_pronounce(audioUrl) {
        if (this.curAudioUrl == audioUrl) {
          return
        }
        let _Player = this.$refs.audioPlayer;
        _Player.pause();
        this.curAudioUrl = audioUrl;
        setTimeout(() => {
          _Player.play();
        }, 200)
      },

      //=========audio==========
      audioEnd() {
        this.curAudioUrl = ''
      },

      //=========net===========
      //添加生词
      request_postAddWord() {
        let params = {
          contentId: this.contentId,
          wordId: this.word.wordId,
          wordName: this.word.wordName
        }
        postAddWord(params).then(result => {
          if (result.code === 0) {
            //gigi'g
            this.$store.dispatch(ActionTypes.UPDATE_WORD_BOOK);
            this.$toast('添加成功')
          }else {
            this.$toast(result.msg)
          }
        })
      }
    },
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import "../../pages/stylesheet/common.styl"
  .overlay {
    background-color: rgba(0, 0, 0, .1);
  }

  .new-word-container {
    width: 100vw;
    color: #fff;
  }

  .word-container {
    margin: 0 auto;
    width: 90%;
    box-sizing: border-box;
    padding: 12px 12px;
    border-radius: 6px;
    background-color: #000;

    .word-and-btn {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .word {
        font-size: 24px;
        font-weight: bold;
      }

      .new-word-btn {
        height: 26px;
        background-color: #000;
        color: #fff;
        border-color: #fff;
        font-size: 13px;
      }

      .sel-new-word-btn {
        color: $common-red;
        border-color: $common-red;
      }
    }

    .pronounce-wrapper {
      display: flex;

      .pronounce-btn {
        margin-right: 16px;
        color: #5E616C;
        display: flex;
        align-items: center;
        .icon{
          margin-left: 6px;
        }
      }

      .pronounce-btn-sel {
        color: $common-red;
      }
    }

    .word-explain {
      margin-top: 10px;
      white-space: pre-line;
    }
  }

  .word-arrow {
    width: 20px;
    transform: translateX(-50%);
    color: #000;
    display: flex;
    height: 10px;

    .arrow {
      font-size: 20px;
      display: inline-block;
      line-height: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// app/components/shengCiAlert/ShengciAlert.vue